export default [
  { label: 'Template #1', value: 'SignatureTemplate1' },
  { label: 'Template #2', value: 'SignatureTemplate2' },
  { label: 'Template #3', value: 'SignatureTemplate3' },
  { label: 'Template #4', value: 'SignatureTemplate4' },
  { label: 'Template #5', value: 'SignatureTemplate5' },
  { label: 'Template #6', value: 'SignatureTemplate6' },
  { label: 'Template #7', value: 'SignatureTemplate7' },
  { label: 'Signature Courrier #1', value: 'SignatureTemplate8' },
  { label: 'Signature Courrier #2', value: 'SignatureTemplate9' }
]
